export default class EditCommitteeCtrl {

	constructor($scope, GeneralSettingsSrv, $mdDialog, $interval, uiGridConstants, i18nService, $state, $stateParams, $cookies, Validations, GlobalConfig, GlobalSrv) {
		i18nService.setCurrentLang('es')
		// constants
		const editCommitteeVM = this

		editCommitteeVM.submodules = {}
		editCommitteeVM.users = {}
		editCommitteeVM.committeeId = {}
		editCommitteeVM.minStartDate = moment().toDate()
		const user = JSON.parse($cookies.get('currentUser'))
		const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

		editCommitteeVM.isCommitteeAdminUser = Validations.isCommitteeAdmin(currentRoleId)

		// variables
		editCommitteeVM.usersFilter = ''
		editCommitteeVM.searchBy = '1'
		editCommitteeVM.searchAdminBy = '1'
		editCommitteeVM.selectedUser = ''
		editCommitteeVM.newCommittee = ''
		editCommitteeVM.committeeUsers = []
		editCommitteeVM.committeeAdminUser = {}
		editCommitteeVM.mappedUsers = []
		editCommitteeVM.selectedTeachers = []
		editCommitteeVM.mappedTeachers = []
		editCommitteeVM.isDisabled = false
		editCommitteeVM.startDate = null
		editCommitteeVM.endDate = null
		editCommitteeVM.selectedSubmodules = []
		editCommitteeVM.mappedSubmodules = []
		editCommitteeVM.minEndDate = moment().toDate()

		// methods
		editCommitteeVM.searchUsers = searchUsers
		editCommitteeVM.highlightFilteredHeader = highlightFilteredHeader
		editCommitteeVM.filter = filter
		editCommitteeVM.singleFilter = singleFilter
		editCommitteeVM.toggle = toggle
		editCommitteeVM.exists = exists
		editCommitteeVM.isIndeterminate = isIndeterminate
		editCommitteeVM.isChecked = isChecked
		editCommitteeVM.toggleAll = toggleAll
		editCommitteeVM.addUserToCommittee = addUserToCommittee
		editCommitteeVM.addAdminUsertoComittee = addAdminUsertoComittee
		editCommitteeVM.dropUser = dropUser
		editCommitteeVM.dropAdminUser = dropAdminUser
		editCommitteeVM.validateForm = validateForm
		editCommitteeVM.saveCommitteeConfig = saveCommitteeConfig
		editCommitteeVM.startDateChanged = startDateChanged
		editCommitteeVM.hasError = hasError
		editCommitteeVM.showErrorMessages = showErrorMessages

		// grid object configuration
		editCommitteeVM.committeeGrid = {
			enableRowHeaderSelection: true,
			enableRowSelection      : true,
			enableSelectAll         : false,
			showGridFooter          : true,
			selectionRowHeaderWidth : 35,
			rowHeight               : 35,
			enableFiltering         : true,
			multiSelect             : true,
			columnDefs              : [
				{
					name            : 'Nombre',
					displayName     : 'Nombre',
					field           : 'teacherName',
					width           : '30%',
					headerCellClass : editCommitteeVM.highlightFilteredHeader,
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Unidad académica',
					displayName     : 'Unidad académica',
					field           : 'academicUnitName',
					width           : '35%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Cédula',
					displayName     : 'Cédula',
					field           : 'identification',
					width           : '25%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				},
			],
			onRegisterApi: (gridApi) => {
				editCommitteeVM.gridApi = gridApi
				editCommitteeVM.gridApi.grid.registerRowsProcessor(editCommitteeVM.singleFilter, 200)
				gridApi.selection.on.rowSelectionChanged($scope, (row) => {
					if (row.isSelected) {
						if (!editCommitteeVM.selectedTeachers.includes(row.entity.teacherId))
							editCommitteeVM.selectedTeachers.push(row.entity.teacherId)
					} else {
						if (editCommitteeVM.selectedTeachers.includes(row.entity.teacherId)) {
							let idx = editCommitteeVM.selectedTeachers.indexOf(row.entity.teacherId)

							editCommitteeVM.selectedTeachers.splice(idx, 1)
						}
					}
				})
				$interval(() => {
					editCommitteeVM.gridApi.core.handleWindowResize()
				}, 500, 10)
			},
		}

		// methods declaration
		function activate() {
			return getCommitteeFormData()
		}

		function getCommitteeFormData() {
			let header = { }

			if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
				header.userId = user.id
				header.rolId = currentRoleId
			}

			return GeneralSettingsSrv.getCommitteeFormData.get(header).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					editCommitteeVM.submodules = dataReturn.submodules
					editCommitteeVM.users = dataReturn.users
					editCommitteeVM.committeeGrid.data = dataReturn.teachers
					getCommittee({ comiteeId: $stateParams.committeeId })
				}
			}).catch((error) => {
				console.log('getCommitteeFormData -> communications failure with server', error)
			})
		}

		function getCommittee(params) {
			return GeneralSettingsSrv.getCommittee.get(params).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					editCommitteeVM.newCommittee = dataReturn.data[0].comiteeName
					editCommitteeVM.committeeId = dataReturn.data[0].comiteeId
					editCommitteeVM.startDate = moment(dataReturn.data[0].startDate, 'YYYY-MM-DD').toDate()
					editCommitteeVM.endDate = moment(dataReturn.data[0].endDate, 'YYYY-MM-DD').toDate()
					editCommitteeVM.userAdmin = dataReturn.data[0].adminUser
					// editCommitteeVM.selectedTeachers = dataReturn.data[0].teachers
					editCommitteeVM.users.forEach((user) => {
						let arr = dataReturn.data[0].users.split(',').map((x) => {return parseInt(x)})

						arr.forEach((id) => {
							if (user.id_code === id) {
								addUserToCommittee(user)
							}
						})
					})
					editCommitteeVM.submodules.forEach((submodule) => {
						let arr = dataReturn.data[0].submodules.split(',').map((x) => {return parseInt(x)})

						arr.forEach((id) => {
							if (submodule.id_code === id) {
								toggle(submodule)
							}
						})
					})

					editCommitteeVM.selectedTeachers = dataReturn.data[0].teachers.split(',')
						.map(teacherId => parseInt(teacherId))

					editCommitteeVM.committeeGrid.data.forEach(professor => {
						if (editCommitteeVM.selectedTeachers.includes(professor.teacherId)) {
							editCommitteeVM.gridApi.selection.selectRow(professor)
						}
					})

					if (editCommitteeVM.userAdmin) {
						const admin = editCommitteeVM.users.find((usr) => usr.id_code === editCommitteeVM.userAdmin)

						editCommitteeVM.committeeAdminUser = admin
					}

					startDateChanged()
				}
			}).catch((error) => {
				console.log('getCommittee -> communications failure with server', error)
			})
		}

		function getNotifyAdmin(params) {
			getSendNotifyAdmin(params)
		}

		function getSendNotifyAdmin(params) {
			let data = {
				rolesId                     : params.rolesId,
				idTeacher                   : null,
				dsName                      : 'Notificación, se editó un comité',
				dsDescription               : 'Administrador de unidad ó modulo: se editó el comité "' + params.comiteeName + '" con las siguientes fechas de inicio: ' + moment(params.startDate).format('DD/MM/YYYY') + ' y fin: ' + moment(params.endDate).format('DD/MM/YYYY'),
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped                  : 1,
			}

			GlobalSrv.addNotificationToAdminWorkPlan.add(data).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					console.log('Notificación exitosa', dataReturn)          
				} else {
					console.log('Error de comunicación en la notificación')
				}
			}).catch((error) => {
				console.error(error)
			})            
			//GlobalSrv.sendNotificationAdmin(data)
		}

		function getSendNotifyExceed(params) {
			let data = {
				idUser                      : user.id,
				idTeacher                   : null,
				dsName                      : 'Notificación, se editó un comité que excede los lineamientos institucionales',
				dsDescription               : 'Sr. Administrador de unidad, el comité "' + params.comiteeName + '" que editó excede los lineamientos institucionales, se modificaron as fechas de inicio: ' + moment(params.startDate).format('DD/MM/YYYY') + ' y fin: ' + moment(params.endDate).format('DD/MM/YYYY'),
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
			}

			GlobalSrv.sendNotificationAdmin(data)
		}

		function updateCommittee(params) {
			return GeneralSettingsSrv.updateCommittee.post(params).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					getNotifyAdmin(params)
					$state.go('generalSettings.users')
					console.log('Permit actualized')
				} else {
					console.log(dataReturn)
				}
			}).catch((error) => {
				editCommitteeVM.isDisabled = false
				console.log('communications failure with server')
			})
		}	

		function searchUsers(text) {
			let matcher = new RegExp(text, 'i')
			let arr = []

			editCommitteeVM.users.forEach((user) => {
				if (editCommitteeVM.searchBy === '1') {
					if (user.ds_fullname.match(matcher)) {
						arr.push(user)
					}
				} else {
					if (user.ds_identification.match(matcher)) {
						arr.push(user)
					}
				}
			})

			return arr
		}

		function highlightFilteredHeader(row, rowRenderIndex, col, colRenderIndex) {
			if (col.filters[0].term) {
				return 'header-filtered'
			} else {
				return ''
			}
		}

		function filter() {
			editCommitteeVM.gridApi.grid.refresh()
		}

		function singleFilter(renderableRows) {
			var matcher = new RegExp(editCommitteeVM.usersFilter, 'i')

			renderableRows.forEach((row) => {
				var match = false;

				[ 'teacherName', 'academicUnitName', 'identification' ].forEach((field) => {
					if (row.entity[field].match(matcher)) {
						match = true
					}
				})

				if (!match) {
					row.visible = false
				}
			})

			return renderableRows
		}

		function toggle(item) {
			let idx = editCommitteeVM.selectedSubmodules.indexOf(item)

			if (idx > -1) {
				editCommitteeVM.selectedSubmodules.splice(idx, 1)
			} else {
				editCommitteeVM.selectedSubmodules.push(item)
			}

			editCommitteeVM.mappedSubmodules = editCommitteeVM.selectedSubmodules.map((submodule) => {
				return { submoduleId: submodule.id_code }
			})
		}

		function exists(item) {
			return editCommitteeVM.selectedSubmodules.indexOf(item) > -1
		}

		function isIndeterminate() {
			return (editCommitteeVM.selectedSubmodules.length !== 0 && editCommitteeVM.selectedSubmodules.length !== editCommitteeVM.submodules.length)
		}

		function isChecked() {
			return editCommitteeVM.selectedSubmodules.length === editCommitteeVM.submodules.length
		}

		function toggleAll() {
			if (editCommitteeVM.selectedSubmodules.length === editCommitteeVM.submodules.length) {
				editCommitteeVM.selectedSubmodules = []
				editCommitteeVM.mappedSubmodules = []
			} else if (editCommitteeVM.selectedSubmodules.length === 0 || editCommitteeVM.selectedSubmodules.length > 0) {
				editCommitteeVM.selectedSubmodules = editCommitteeVM.submodules.slice(0)
				editCommitteeVM.mappedSubmodules = editCommitteeVM.submodules.slice(0).map((submodule) => {
					return { submoduleId: submodule.id_code }
				})
			}
		}

		function addUserToCommittee(user) {
			if (user && !editCommitteeVM.committeeUsers.includes(user)) {
				editCommitteeVM.committeeUsers.push(user)
				editCommitteeVM.mappedUsers.push({ userId: user.id_code })
			}

			editCommitteeVM.searchText = ''
		}

		function addAdminUsertoComittee(user) {
			if (user && editCommitteeVM.committeeAdminUser !== user) {
				editCommitteeVM.committeeAdminUser = user
			}

			editCommitteeVM.searchAdminText = ''
		}

		function dropUser(idx) {
			editCommitteeVM.committeeUsers.splice(idx, 1)
			editCommitteeVM.mappedUsers.splice(idx, 1)
		}
		function dropAdminUser() {
			editCommitteeVM.comitteeAdmin = {}
		}

		function saveCommitteeConfig() {
			editCommitteeVM.isDisabled = true
			editCommitteeVM.selectedTeachers = editCommitteeVM.selectedTeachers.map((id) => {
				return { teacherId: id }
			})
			let params = {
				comiteeAdminUser: editCommitteeVM.committeeAdminUser.id_code || null,
				comiteeId       : editCommitteeVM.committeeId,
				roleId          : 4,
				comiteeName     : editCommitteeVM.newCommittee,
				comiteeTypeId   : 1,
				startDate       : moment(new Date(editCommitteeVM.startDate)).format('YYYY-MM-DD hh:mm:ss'),
				endDate         : moment(new Date(editCommitteeVM.endDate)).format('YYYY-MM-DD hh:mm:ss'),
				users           : editCommitteeVM.mappedUsers,
				submodules      : editCommitteeVM.mappedSubmodules,
				teachers        : editCommitteeVM.selectedTeachers,
				rolesId         : [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.adminUnit, GlobalConfig.userRolesIds.adminModule ],
			}

			updateCommittee(params)
		}

		function startDateChanged() {
			let m = moment(editCommitteeVM.startDate)

			editCommitteeVM.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : moment().toDate()
		}

		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched))
				return 'has-error'
		}

		function showErrorMessages(input) {
			return input.$dirty || input.$touched
		}

		function validateForm() {

		}

		// initialization
		activate()
	}//FIN DEL CONSTRUCTOR

	preventInput(event) {
		var vKey = 86

		if (event.keyCode == vKey)
			event.preventDefault()

		return     
	}

}

EditCommitteeCtrl.$inject = [ '$scope', 'GeneralSettingsSrv', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', '$stateParams', '$cookies', 'Validations', 'GlobalConfig', 'GlobalSrv' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/users/edit/editCommitteeCtrl.js